export const GET_ANALYSIS_LIST_IN_PROGRESS = 'GET_ANALYSIS_LIST_IN_PROGRESS';
export const GET_ANALYSIS_LIST_SUCCESS = 'GET_ANALYSIS_LIST_SUCCESS';
export const GET_ANALYSIS_LIST_FAIL = 'GET_ANALYSIS_LIST_FAIL';
export const GET_ANALYSIS_INFO_IN_PROGRESS = 'GET_ANALYSIS_INFO_IN_PROGRESS';
export const GET_ANALYSIS_INFO_SUCCESS = 'GET_ANALYSIS_INFO_SUCCESS';
export const GET_ANALYSIS_INFO_FAIL = 'GET_ANALYSIS_INFO_FAIL';
export const MARK_ANALYSIS_AS_VIEWED_SUCCESS = 'MARK_ANALYSIS_AS_VIEWED_SUCCESS';
